/* RESPONSIBLE TEAM: team-frontend-tech */
import { attr } from '@ember-data/model';
import PredicateGroup from 'predicates/models/predicate-group';

export default PredicateGroup.extend({
  name: attr('string'),
});
